import { lazy, Suspense } from 'react'

import Loader from 'react-loaders'
import { Route, Routes } from 'react-router-dom'

import Home from './components/Home'
import Layout from './components/Layout'
import Soundbar from './components/Soundbar'
import './App.scss'

const About = lazy(() => import('./components/About'))
const Experience = lazy(() => import('./components/Experience'))
const Projects = lazy(() => import('./components/Projects'))
const Skills = lazy(() => import('./components/Skills'))
const Contact = lazy(() => import('./components/Contact'))

function App() {
  return (
    <>
      <Soundbar />
      <Suspense fallback={<Loader type="pacman" />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="experience" element={<Experience />} />
            <Route path="projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/skills" element={<Skills />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  )
}

export default App
